module.exports = __webpack_public_path__ + "img/eye.ee7d357a.jpg";